import React, {cloneElement, useState} from 'react';
import {
    Button,
    Datagrid,
    DateField,
    DeleteButton,
    List,
    sanitizeListRestProps,
    TextField,
    TopToolbar,
    usePermissions
} from 'react-admin';
import DeleteRunField from "../../UIComponents/deleteRunField";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AuditLogHistory from '../payroll/AuditLogHistory';

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button as MuiButton } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import CaptionedField from "../../UIComponents/captionedField";
import CardActions from "@material-ui/core/CardActions";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewGridIcon from "@material-ui/icons/ViewModule"
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/LibraryBooksOutlined"
import AuditIcon from "@material-ui/icons/Security"
import {Link} from "react-router-dom";
import ApproveButton from "../payroll/approveButton";
import Chip from "@material-ui/core/Chip";
import {Typography} from "../../UIComponents/Wrappers";
import MultiCurrencyField from "../../UIComponents/multiCurrencyField";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import UnlockPayrollButton from "../payroll/unlockButton";
import UnApproveButton from "../payroll/unApproveButton";
import SetReadyPayrollButton from "../payroll/setReadyButton";
import {MultiCurrencyContext} from "../../contexts";
import MultiDate from "../../UIComponents/multiDate";
import MultiDateField from "../../UIComponents/multiDateField";

const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
};
const PayrunGrid = ({ ids, data, basePath,permissions, onUnlock }) => {
    const [selectedPayroll, setSelectedPayroll] = useState(null);
    const [auditLogOpen, setAuditLogOpen] = useState(false);

    const handleAuditLogOpen = (record) => {
        setSelectedPayroll(record);
        setAuditLogOpen(true);
    };

    const handleAuditLogClose = () => {
        setAuditLogOpen(false);
        setSelectedPayroll(null);
    };

    return (
    <div style={{ margin: '1em' }}>
        <Grid container spacing={2}>
        {ids.map(id =>
            <Grid item xs={12} sm={6} lg={4} key={id}>
            <MultiCurrencyContext.Provider value={data[id].usedCurrencyRates}>
            <Card style={cardStyle}>
                <CardHeader
                    // title={ <DateField record={data[id]} source="payrollDate" options={{year: 'numeric', month: 'long'}}/>}
                    title={ <MultiDateField record={data[id]} source="payrollDate" format={'MMMM YYYY'} />}
                    // subheader={<DateField record={data[id]} source="runDate"    showTime={true}  />}
                    subheader={<MultiDateField record={data[id]} source="runDate" format={'MM/DD/YYYY HH:mm'} />}
                    action={
                        <>
                            {/* <SetReadyPayrollButton permissions={permissions} record={data[id]}/> */}
                       <IconButton 
                           onClick={() => handleAuditLogOpen(data[id])}
                           color="primary"
                           title="Show Audit Log"
                       >
                           <AuditIcon /> 
                       </IconButton>
                       <UnlockPayrollButton permissions={permissions} record={data[id]}/>
                  </>
                    }
                />
                <CardContent>
                    {/*<MultiDate gcDate={data[id].payrollDate} />*/}
                    <Grid>
                    {data[id].description||''}
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <CaptionedField value={data[id].totalIncome} label='Total Income' />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CaptionedField value={data[id].netPay} label='Net (before settlement)' />
                        </Grid>
                    </Grid>
             
                    <Grid container>
<Grid xs={12} sm={8} item>
                        <Typography>
                            Run By {data[id].createdBy}
                        </Typography>
                        <Typography>
                          {data[id].status === "Waiting" ? data[id].status : 
                            <><Chip 
                                label={data[id].status} 
                                color="primary"
                                onClick={() => handleAuditLogOpen(data[id])}
                                style={{ cursor: 'pointer' }}
                            /> by {
                              data[id].status === "Approved" ? data[id].approvedBy : 
                              (data[id].status === "Reviewed" && data[id].remarks && data[id].remarks.length > 0) ? 
                                data[id].remarks[data[id].remarks.length - 1].user : 
                                data[id].status === "ReadyForApproval"? data[id].checkedBy: ''
                            }</>
                          }
                        </Typography>
                    </Grid>
                    <Grid item>
                        <CaptionedField value={data[id].cash} label='Net Pay' />
                    </Grid>
                    </Grid>

                  


                </CardContent>
                {/*<CardContent>*/}
                    {/*about&nbsp;*/}
                    {/*<ReferenceField label="Post" resource="comments" record={data[id]} source="post_id" reference="posts" basePath={basePath}>*/}
                        {/*<TextField source="title" />*/}
                    {/*</ReferenceField>*/}
                {/*</CardContent>*/}
                <CardActions style={{ textAlign: 'right', flexWrap: 'wrap' }}>
                    <Button component={Link} to={`/reports/payroll/${id}/sheet`}  startIcon={<ViewIcon/>}  label='reports'/>
                    <Button component={Link} to={`/runPayroll/${id}`}  startIcon={<EditIcon/>}  label='edit'/>
                    <DeleteButton disabled={data[id].locked||(data[id].status==='Approved')||(!(permissions.includes("Manager")&&permissions.includes("Manager"))&&data[id].createdBy.toLowerCase()!==localStorage.getItem('user').toLowerCase())} resource="payrollRuns" basePath={basePath} record={data[id]}/>
                    {/*<EditButton resource="posts" basePath={basePath} record={data[id]} />*/}
                    {
                        (permissions.includes('Manager')||permissions.includes('DManager')) &&   data[id].status !== 'Approved' &&    <ApproveButton record={data[id]}/>
                    }
                    {
                        !data[id].locked && (permissions.includes('Manager')||permissions.includes('DManager')) && permissions.includes('Admin') &&  data[id].status === 'Approved' &&    <UnApproveButton record={data[id]}/>
                    }

                </CardActions>
            </Card>
            </MultiCurrencyContext.Provider>
            </Grid>
        )}
        </Grid>

        <Dialog
            open={auditLogOpen}
            onClose={handleAuditLogClose}
            maxWidth="md"
            fullWidth
        >
            <DialogContent>
                {selectedPayroll && <AuditLogHistory auditLogMeta={selectedPayroll.auditLogMeta} defaultExpanded={true} />}
            </DialogContent>
        </Dialog>
    </div>
    );
};
PayrunGrid.defaultProps = {
    data: {},
    ids: [],
};

const PayrunMobileList = ({ ids, data, basePath, permissions }) => {
    const [selectedPayroll, setSelectedPayroll] = useState(null);
    const [auditLogOpen, setAuditLogOpen] = useState(false);

    const handleAuditLogOpen = (record) => {
        setSelectedPayroll(record);
        setAuditLogOpen(true);
    };

    const handleAuditLogClose = () => {
        setAuditLogOpen(false);
        setSelectedPayroll(null);
    };

    return (
        <div style={{ margin: '0.5em' }}>
            {ids.map(id => {
                const record = data[id];
                return (
                    <MultiCurrencyContext.Provider value={record.usedCurrencyRates} key={id}>
                        <Card style={{ marginBottom: 12 }}>
                            <CardContent style={{ paddingBottom: 0 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <MultiDateField record={record} source="payrollDate" format={'MMMM YYYY'} />
                                    <MultiCurrencyField record={record} source="netPay" />
                                </div>
                                <Typography variant="caption" style={{ display: 'block', marginTop: 4 }}>
                                    <MultiDateField record={record} source="runDate" format={'MM/DD/YYYY HH:mm'} />
                                    {' · '}{record.status}{' · '}{record.createdBy}
                                </Typography>
                            </CardContent>
                            <CardActions style={{ flexWrap: 'wrap' }}>
                                <MuiButton variant="outlined" size="small" color="primary"
                                        component={Link} to={`/reports/payroll/${id}/sheet`}
                                        startIcon={<ViewIcon />}>
                                    Report
                                </MuiButton>
                                {(permissions.includes('Manager') || permissions.includes('DManager')) && record.status !== 'Approved' &&
                                    <ApproveButton record={record} />}
                            </CardActions>
                            <CardActions style={{ paddingTop: 0, flexWrap: 'wrap' }}>
                                {record.status !== "Approved" && record.createdBy.toLowerCase() === localStorage.getItem('user').toLowerCase() &&
                                    <MuiButton variant="outlined" size="small" color="primary"
                                            component={Link} to={`/runPayroll/${id}`}
                                            startIcon={<EditIcon />}>
                                        Edit
                                    </MuiButton>}
                                <DeleteButton
                                    disabled={record.locked || record.status === 'Approved' || (!(permissions.includes("Admin") && permissions.includes("Manager")) && record.createdBy.toLowerCase() !== localStorage.getItem('user').toLowerCase())}
                                    resource="payrollRuns" basePath={basePath} record={record} label={null} />
                                <UnlockPayrollButton permissions={permissions} record={record} />
                                <IconButton color="primary" title="Show Audit Log" onClick={() => handleAuditLogOpen(record)}>
                                    <AuditIcon />
                                </IconButton>
                            </CardActions>
                        </Card>
                    </MultiCurrencyContext.Provider>
                );
            })}

            <Dialog
                open={auditLogOpen}
                onClose={handleAuditLogClose}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    {selectedPayroll && <AuditLogHistory auditLogMeta={selectedPayroll.auditLogMeta} defaultExpanded={true} />}
                </DialogContent>
            </Dialog>
        </div>
    );
};






const PayrollrunActions =({
                              onViewChange,
                              currentSort,
                              className,
                              resource,
                              filters,
                              displayedFilters,
                              exporter, // you can hide ExportButton if exporter = (null || false)
                              filterValues,
                              permanentFilter,
                              hasCreate, // you can hide CreateButton if hasCreate = false
                              basePath,
                              selectedIds,
                              onUnselectItems,
                              showFilter,
                              maxResults,
                              total,
                              ...rest
                          }) => (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
        {filters && cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <IconButton color='primary'  aria-label="Grid View" onClick={()=>onViewChange('grid')}>
            <ViewGridIcon fontSize="large" />
        </IconButton>
        <IconButton color='primary' aria-label="List View" onClick={()=>onViewChange('list')}>
            <ViewListIcon fontSize="large" />
        </IconButton>


    </TopToolbar>
);


const ViewSelector = props => {
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

    if (isMobile) {
        return <PayrunMobileList {...props} />;
    }

    return <>{props.view === 'list' &&
    <Datagrid {...props}
                                           isRowSelectable={record => record.status !== "Approved" && ((props.permissions.includes("Admin")&&(props.permissions.includes("Manager")||props.permissions.includes("DManager"))) || record.createdBy.toLowerCase() === localStorage.getItem('user').toLowerCase())}>
        {/*<TextField source="id" />*/}
        <DateField source="runDate"/>
        <DateField source="payrollDate" options={{year: 'numeric', month: 'long'}}/>
        <TextField source="createdBy"/>
        <TextField source="status"/>
        <MultiCurrencyField source="netPay"/>
        <DeleteRunField permissions={props.permissions}/>
    </Datagrid>}
        {props.view === 'grid' && <PayrunGrid {...props}/>}
    </>
}
export const PayrollRunList= props => {
    const [view,setView] = useState('grid');
    const permissions= usePermissions()
    if (!permissions.permissions) return null;


   return   <List actions={<PayrollrunActions onViewChange={setView}/>} exporter={false}  {...props} sort={{field: 'runDate', order: 'DESC'}}>
     <ViewSelector  permissions={permissions.permissions} view={view}/>
    </List>
};


